/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { useEffect, useState } from "react";
import { SimpliCitySDK } from "../sdk";
import { Logger } from "cms/utils/logger";
import { useAuth } from "cms/auth/hooks/useAuth";
import { isValidGuid } from "../utils/empty-exists";

const useSimpliCityImageLoader = (guid) => {

    const { token } = useAuth();
    const [image, setImage] = useState();
    const [imageGuid, setImageGuid] = useState();

    useEffect(() => {
        const fetchImage = async () => {
            try {
                // debugger
                if (!guid) {
                    setImage(undefined);
                    console.info("Could not load image. GUID missing.");
                } else if (imageGuid !== guid) {
                    let _image = await SimpliCitySDK.image.findOne(token, guid);
                    if (_image && isValidGuid(_image?.guid)) {
                        setImage(_image);
                        setImageGuid(_image?.guid);
                        // debugger
                        Logger.debug("setImage", _image);
                    } else {
                        // debugger
                        Logger.debug("Could not load Image...", guid);
                    }
                } else {
                    setImage(undefined);
                }
            } catch (error) {
                // debugger
                console.warn(error);
            }
        };
        fetchImage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guid]);

    return image;
};

export { useSimpliCityImageLoader };
